import React from "react";

const LoadMore = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M28.46 30.108A15.937 15.937 0 0 1 18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16c0 3.418-1.072 6.585-2.897 9.185L26 18h4.8c0-7.07-5.73-12.8-12.8-12.8S5.2 10.93 5.2 18 10.93 30.8 18 30.8c3.44 0 6.564-1.357 8.864-3.565l1.596 2.873Z"
              fill={fill}
        />
    </svg>
);

export default LoadMore;